import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class StockAddConfigService {
  
  getStockConfig(): InlineAddConfig {
    return {
      modelType: 'stock',
      title: 'Stock',
      apiEndpoint: 'api/stocks/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'stockCode': 'code'
      },
      selectionConfig: {
        targetField: 'stockId',
        valueField: 'id',
        labelField: 'name'
      },
      hiddenData: {
        isActive: true,
        uoms: [
          {
            code: "UNIT(S)",
            eInvoiceUOMCode: null,
            description: "--BASE UOM--",
            rate: 1,
            barcode: null,
            isBase: true,
            isActive: true,
            salesPrice: 0,
            purchasePrice: 0,
            minPrice: 0,
            salesDiscount: null,
            purchaseDiscount: null
          }
        ]
      },
      fields: [
        {
          name: 'code',
          label: 'Stock/Service #',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter stock/service code',
          size: 'half'
        },
        {
          name: 'name',
          label: 'Stock/Service Name',
          type: 'text',
          isInstantData: true,
          required: true,
          maxLength: 200,
          placeholder: 'Enter stock/service name',
          size: 'half'
        },
        {
          name: 'accountPresetId',
          label: 'Account Preset',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select account preset',
          size: 'half',
          searchConfig: {
            url: 'api/stockaccountpresets/lookup',
            searchFields: ['code', 'name'],
            defaultFilter: '',
            orderby: 'code desc'
          }
        },
        {
          name: 'categoryId',
          label: 'Category',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select category',
          size: 'half',
          searchConfig: {
            url: 'api/StockCategories/Query',
            searchFields: ['code', 'name']
          }
        },
        {
          name: 'groupId',
          label: 'Group',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select group',
          size: 'half',
          searchConfig: {
            url: 'api/StockGroups/Query',
            searchFields: ['code', 'name']
          }
        },
        {
          name: 'classId',
          label: 'Class',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select class',
          size: 'half',
          searchConfig: {
            url: 'api/StockClasses/Query',
            searchFields: ['code', 'name']
          }
        }
      ]
    };
  }
} 